export enum BuilderBreakpoint {
    Phone = 'phone',
    Tablet = 'tablet',
    Laptop = 'laptop',
    Desktop = 'desktop',
}
